__turbopack_context__.v({
  "arrow": "promotion-announcement-banner-module-scss-module___AbC2W__arrow",
  "banner": "promotion-announcement-banner-module-scss-module___AbC2W__banner",
  "cta": "promotion-announcement-banner-module-scss-module___AbC2W__cta",
  "inner": "promotion-announcement-banner-module-scss-module___AbC2W__inner",
  "text": "promotion-announcement-banner-module-scss-module___AbC2W__text",
});
